<template >
	<div v-if="inCreateMode">
		<closing-days-form
			:period="period"
			:translations="translations"
			:check-overlap="checkOverlap"
			@save="save"
			@cancel="cancel"
		></closing-days-form>
	</div>
	<div v-else :class="{'is-loading': loader.loading}">
		<button class="button is-success" @click="create" :disabled="this.loader.loading">
			{{ translations['buttons']['add_period'] }}
		</button>
	</div>
</template>

<script>

import ClosingDaysForm from "./closing-days-form";

export default {
	name: "closing-days-create",
	components: {
		ClosingDaysForm
	},
	props: [ 'url', 'translations', 'checkOverlap' ],
	emits: [ 'created' ],
	data() {
		return {
			inCreateMode: false,
			loader: {
				loading: false,
			},
			period: {
				closed_from: null,
				closed_until: null,
				block_card_creation_from: null,
			}
		}
	},
	methods: {
		create()
		{
			this.inCreateMode = true;
		},
		cancel()
		{
			this.inCreateMode = false;
		},
		save()
		{
			this.inCreateMode = false;
			(new ApiMonizze(new LoaderState(this.loader)))
				.postDataFromApi(
					this.url,
					this.period,
					(data) => {
						this.$emit('created', data);
						this.period = {
							closed_from: null,
							closed_until: null,
							block_card_creation_from: null,
						};
					}
				);
		}
	}
}
</script>
